import React, { ChangeEvent, Dispatch, forwardRef, useCallback, useImperativeHandle, useState } from 'react';
import { Auth, Storage } from 'aws-amplify';
import { Button, Box, Image, Text, VStack, Spinner, Input, IconButton, HStack, useColorModeValue, Tooltip } from '@chakra-ui/react';
import { MdOutlineInsertPhoto } from 'react-icons/md';
import { CloseIcon } from '@chakra-ui/icons';
import { FileAndImageUrl } from '../../types/types';
import { useSelector } from 'react-redux';
import { selectBeeBotModel } from '../../../../store/store';

// TODO 1: add session ID to the upload path
// Task 3: Restrict S3 file type of images only - no longer applicable, text files and others are now allowed but OpenAI API may not process them

interface Props {
    imageUrls?: FileAndImageUrl[];
    setImageUrls: Dispatch<React.SetStateAction<FileAndImageUrl[]>>;
}

export interface ImageUploadButtonComponentRef {
    uploadFiles: (files: FileList) => void;
}

const ImageUploadButton = forwardRef<ImageUploadButtonComponentRef, Props>(({ imageUrls = [], setImageUrls }: Props, ref) => {
    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<string | null>(null);

    // Model
    const model = useSelector(selectBeeBotModel);

    const bgColorIcon = useColorModeValue(
        '#f1f5f9',
        '#1e293b'
    )

    useImperativeHandle(ref, () => {
        return {
            // ... your methods ...
            uploadFiles,

        };
    }, []);


    const handleFileChange = async (event: ChangeEvent<HTMLInputElement>) => {
        const files = event.target.files;
        if (!files) return;
        // console.log('files', files);
        // console.log('changeEvent', event);

        await uploadFiles(files);

    }

    const uploadFiles = async (files: FileList) => {
        if (!files) return;

        setLoading(true);
        setError(null);

        try {
            // Get the current authenticated user
            const user = await Auth.currentAuthenticatedUser();
            const userId = user.username;

            const uploadPromises = Array.from(files).map(async (file) => {
                // Create a unique key for the file based on user ID
                const fileKey = `${userId}/${file.name}`;

                // Upload the file to S3 with private access
                await Storage.put(fileKey, file, {
                    contentType: file.type,
                    level: 'private',
                    cacheControl: `max-age=${60 * 60 * 24 * 30}` // Expires in 30 days (measured in seconds)
                });

                // Get a public URL for the uploaded file valid for 12 hours
                const publicUrl = await Storage.get(fileKey, {
                    level: 'private',
                    expires: 60 * 60 * 12, // 12 hours
                });

                return { url: publicUrl, key: fileKey };
            });

            const urls = await Promise.all(uploadPromises);
            setImageUrls(prev => ([...prev, ...urls]));
            console.log('Images uploaded successfully:', urls);
        } catch (error) {
            console.error('Error uploading image:', error);
            setError('Error uploading images. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    // const handleDelete = useCallback(async (key: string) => {
    //     try {
    //         // Delete the file from S3
    //         await Storage.remove(key, { level: 'private' });

    //         // Remove the image from the state
    //         setImageUrls((prevUrls) => prevUrls.filter((image) => image.key !== key));
    //         console.log('File deleted successfully:', key);
    //     } catch (error) {
    //         console.error('Error deleting file:', error);
    //         setError('Error deleting file. Please try again.');
    //     }
    // }, []);

    return (
        <div>
            {/* <input
                type="file"
                id="fileInput"
                onChange={handleFileChange}
                style={{ display: 'none' }}
            /> */}
            <Input
                type='file'
                accept="image/*" // This restricts the input to image files
                id="imageInput"
                onChange={handleFileChange}
                multiple
                display="none"
            />
            {/* <button
                onClick={() => document.getElementById('fileInput').click()}
                disabled={loading}
            >
                {loading ? 'Uploading...' : 'Upload Image'}
            </button> */}
            <Tooltip
                label={model?.acceptImages ? 'Upload images' : `${model?.name} model does not accept images`}
                placement="right"
                hasArrow
                bg="gray.700"
                color="white"
                borderRadius="md"
                px="3"
                py="2"
            >
                <Button
                    id={'imageUploadButton.tsx'}
                    aria-label="Insert photo"
                    w={'fit'}
                    variant="secondary"
                    bg={bgColorIcon}
                    onClick={(e) => {
                        if (loading || !model?.acceptImages) {
                            e.preventDefault();
                            return;
                        }
                        document.getElementById('imageInput')?.click()
                    }}
                    disabled={loading || !model?.acceptImages}
                    opacity={loading || !model?.acceptImages ? 0.5 : 1}
                    cursor={loading || !model?.acceptImages ? 'not-allowed' : 'pointer'}
                >
                    {loading
                        ? <Spinner
                            thickness='4px'
                            speed='0.65s'
                            emptyColor='gray.200'
                            color='blue.500'
                            size='xs'
                        />
                        : <MdOutlineInsertPhoto className="text-xl" />}
                </Button>
            </Tooltip>

            {/* 
            {imageUrls.length > 0 && (
                <Box mt={2}>
                    <Text>Images uploaded successfully. Public URLs (valid for 1 hour):</Text>
                <HStack spacing={4} mt={2}>
                    {imageUrls.map((image, index) => (
                        <Box key={index} position="relative">
                            <a href={image.url} target="_blank" rel="noopener noreferrer">
                                {image.url}
                            </a>
                            <Image
                                src={image.url}
                                alt={`Uploaded Thumbnail ${index + 1}`}
                                boxSize="100px"
                                objectFit="cover"
                                borderRadius="md"
                                mt={2}
                            />
                            <IconButton
                                aria-label="Delete image"
                                icon={<CloseIcon />}
                                size="sm"
                                position="absolute"
                                top="3"
                                right="1"
                                onClick={() => handleDelete(image.key)}
                            />
                        </Box>
                    ))}
                </HStack>
            </Box>
            )
        }
        { error && <p style={{ color: 'red' }}>{error}</p> }
            */}
        </div >
    );
});

export default ImageUploadButton;